import testRecord from './testRecord'
import testManage from './testManage'
import scoreSearch from './scoreSearch'

export default {
  testRecord,
  testManage,
  scoreSearch
}
